import { InputCurrency } from "@sellar-io/components";
import type {
  PriceListListResponseType,
  ProductPriceListBatchCreateRequestType,
} from "@sellar-io/api-v2/types";
import { twMerge } from "tailwind-merge";
import { InputContainer } from "@sellar-io/components";
import {
  TableLegacyTR,
  TableLegacyTD,
} from "../../../../../components/table/TableLegacy";
import {
  formatPriceInputToApi,
  usePriceFormat,
} from "../../../../../hooks/usePriceFormat";

const handleUpdateItems = (
  priceListItems: ProductPriceListBatchCreateRequestType | undefined,
  ProductId: number,
  PriceListId: number,
  price: number | null,
) => {
  if (price !== null && price < 0) return priceListItems;

  const filteredPriceListItems = (priceListItems ?? []).filter(
    (item) => item.PriceListId !== PriceListId,
  );

  if (price !== null && price >= 0) {
    filteredPriceListItems.push({
      ProductId,
      basePrice: null,
      price,
      PriceListId,
      active: true,
      discountable: true,
    });
  }

  return filteredPriceListItems;
};

export default function ItemPricingTableRow({
  priceList,
  productId,
  updatedPriceListItems,
  setUpdatedPriceListItems,
  warning,
}: {
  productId: number;
  priceList: PriceListListResponseType[number];
  setUpdatedPriceListItems: (
    item: ProductPriceListBatchCreateRequestType | undefined,
  ) => void;
  updatedPriceListItems: ProductPriceListBatchCreateRequestType | undefined;
  warning: boolean;
}) {
  const price = updatedPriceListItems?.find(
    (item) => item.PriceListId === priceList.id,
  )?.price;
  const priceFormat = usePriceFormat(price);

  return (
    <TableLegacyTR>
      <TableLegacyTD>{priceList.name}</TableLegacyTD>
      <TableLegacyTD>
        <InputContainer
          className={twMerge(
            "w-[16ch]",
            warning &&
              !updatedPriceListItems?.length &&
              "shadow-[0_0px_8px_0_rgba(249,115,22,0.75)]",
          )}
        >
          <InputCurrency
            showPrefix
            allowNegative
            placeholder="No price"
            value={priceFormat.inputFormat}
            onChange={(e) => {
              priceFormat.setInputFormat(e.target.value);
              const price = formatPriceInputToApi(e.target.value);
              setUpdatedPriceListItems(
                handleUpdateItems(
                  updatedPriceListItems,
                  productId,
                  priceList.id,
                  price,
                ),
              );
            }}
          />
        </InputContainer>
      </TableLegacyTD>
    </TableLegacyTR>
  );
}
